export default __webpack_public_path__ + "static/media/bell.799123aa.svg";